import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { defaultCustomToolSize } from '../dms-viewer-configuration-constants';
export function createRubberStampTool(webViewer, toolName, image) {
  var Tool = /*#__PURE__*/function (_webViewer$Core$Tools) {
    function Tool(webViewer) {
      _classCallCheck(this, Tool);
      return _callSuper(this, Tool, [webViewer.Core.documentViewer]);
    }
    _inherits(Tool, _webViewer$Core$Tools);
    return _createClass(Tool, [{
      key: "mouseLeftUp",
      value: function () {
        var _mouseLeftUp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _superPropGet(Tool, "mouseLeftUp", this, 3)([e]);
                _context.next = 3;
                return this.setStampAnnotation();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function mouseLeftUp(_x) {
          return _mouseLeftUp.apply(this, arguments);
        }
        return mouseLeftUp;
      }()
    }, {
      key: "switchIn",
      value: function () {
        var _switchIn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setStampAnnotation();
              case 2:
                this.showPreview();
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function switchIn() {
          return _switchIn.apply(this, arguments);
        }
        return switchIn;
      }()
    }, {
      key: "switchOut",
      value: function switchOut() {
        this.hidePreview();
      }
    }, {
      key: "setStampAnnotation",
      value: function () {
        var _setStampAnnotation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var annotation, annotationWithImage;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                annotation = new webViewer.Core.Annotations.StampAnnotation();
                annotation.Icon = toolName;
                _context3.next = 4;
                return annotation.setImageData(image);
              case 4:
                annotationWithImage = annotation;
                annotationWithImage.image.height = defaultCustomToolSize.height;
                annotationWithImage.image.width = defaultCustomToolSize.width;
                _context3.next = 9;
                return this.setRubberStamp(annotation, toolName);
              case 9:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function setStampAnnotation() {
          return _setStampAnnotation.apply(this, arguments);
        }
        return setStampAnnotation;
      }()
    }]);
  }(webViewer.Core.Tools.RubberStampCreateTool);
  return new Tool(webViewer);
}
export function registerRubberStampTool(webViewer, toolName, image) {
  var stampTool = createRubberStampTool(webViewer, toolName, image);
  webViewer.UI.registerTool({
    toolObject: stampTool,
    toolName: toolName,
    tooltip: 'tool.' + toolName.replace(/\s/g, ''),
    buttonImage: image,
    buttonName: toolName
  });
}
